import React from "react";
import { useI18n } from "../i18n";

const HowItWorks = () => {
  const { t } = useI18n();
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 relative">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/4269361/pexels-photo-4269361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-600 mb-4">
            {t.process.eyebrow}
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-slate-900">
            {t.process.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200 rounded-2xl overflow-hidden">
          {t.process.steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i}`}
              className="bg-white p-8 md:p-10 hover:bg-slate-50 transition-colors relative group"
            >
              <div className="font-display text-6xl font-light text-slate-200 group-hover:text-sky-200 transition-colors">
                {s.n}
              </div>
              <h3 className="font-display text-xl md:text-2xl font-semibold text-slate-900 mt-4">
                {s.name}
              </h3>
              <p className="mt-3 text-slate-600 text-sm md:text-base leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
